import React, { useContext, useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import Image from 'next/image';
import { gsap } from 'gsap/dist/gsap';
import { useRouter } from 'next/router';
import { useWindowSize } from 'u9/hooks';
import Flickity from "react-flickity-component";
import { ScrollTrigger } from 'gsap/dist/ScrollTrigger';

import Footer from 'u9/containers/footer/footer'
import HaveQuestions from 'u9/containers/haveQuestions/haveQuestion'

import { colors } from 'utils/styles/theme';
import { BaseContextType, BaseContext } from 'u9/contexts/base';
import { Layout, Bg, LayoutTitle, Caption, Title, LayoutWrapper,  LayoutOverview, FlickityWrapper, CarouselCell,  LayoutBlock0, LayoutBlock1, LayoutBlock2, LayoutBGWBackdrop, LayoutImageWCaption } from 'u9/containers/work/work.styles' ;
import { cmsApiClient } from 'utils/api/cms';
import { ISR_TIMEOUT } from 'utils/config';
import { GetServerSideProps } from 'next';
import { gql } from '@apollo/client';
import { Category, Client, DynamicZone, ImageFormat } from 'u9/contexts/base.types';
import Head from 'u9/components/Head';


interface WorkProps {
  title: string,
  client: Client,
  year: number,
  category: Category,
  relatedCategories: [Category],
  cover: ImageFormat,
  dynamicZone:[DynamicZone]
}

const Work = ({ title, client, year, category, relatedCategories, cover, dynamicZone, ...restProps }: WorkProps) => {

  const { setMenuHidden, setWorksActive }: BaseContextType = useContext(BaseContext);

  const windowSize = useWindowSize();
  let [carouselIndex, setCarouselIndex] = useState(null);
  const heroRef = useRef<HTMLDivElement>(null);

  let flkty;

  const handleChange = index => {
    setCarouselIndex(index);
  };

  useEffect(() => {
    if (flkty) {
      flkty.on("settle", () => {
        //flkty.selectedIndex
      });

      flkty.on("change", index => {
        handleChange(index);
      });

      flkty.on("scroll", index => {
        flkty.slides.forEach( function( slide, i ) {
          // var img = $imgs[i];
          // var x = ( slide.target + flkty.x ) * -1/3;
          // img.style[ transformProp ] = 'translateX(' + x  + 'px)';
        });
      });
    }
  }, [carouselIndex]);

  useEffect(() => {

    gsap.to(heroRef.current, {
      scrollTrigger: {
        trigger: heroRef.current,
        start: "top top",
        end: "bottom top",
        scrub: true,
        invalidateOnRefresh: true,
        anticipatePin: 1
      },
      yPercent: 25
    });
    setMenuHidden(true)
    setWorksActive(true);

    return () => {
      setWorksActive(false)
    }
  }, [])

  useEffect(() => {
    const staggerOffset = 25
    gsap.set(".staggerInView", {y: staggerOffset, opacity: 0});

    ScrollTrigger.batch(".staggerInView", {
      interval: 0.1,
      batchMax: 1,
      start: `top bottom-=${windowSize.height*.1}`,
      end: `bottom top+=${windowSize.height*.1}`,
      anticipatePin: 1,
      onEnter: batch => gsap.to(batch, {autoAlpha: 1, y: 0, stagger: 0.15, overwrite: true, duration: 0.3612}),
      onLeave: batch => gsap.to(batch, {autoAlpha: 0, y: -staggerOffset, overwrite: true, duration: 0.3612}),
      onEnterBack: batch => gsap.to(batch, {autoAlpha: 1, y: 0, stagger: 0.15, overwrite: true, duration: 0.3612}),
      onLeaveBack: batch => gsap.to(batch, {autoAlpha: 0, y: staggerOffset, overwrite: true, duration: 0.3612})
    });

  }, [])

  const scrollRefresh = () => {
    ScrollTrigger.refresh();
  }
  useEffect(() => {
    scrollRefresh()
  })

  return (
    // <motion.div
    //   initial={{ opacity: 0 }}
    //   animate={{ opacity: 1 }}
    //   exit={{ opacity: 0 }}
    //   {...restProps}
    // >
    <>
      <Head title={`U9T: Our Work - ${title}`}/>
      <Bg ref={heroRef}>
        {cover &&
          <Image
            src={cover?.formats?.large?.url || cover?.formats?.medium?.url || cover?.formats?.small?.url}
            layout="fill"
            objectFit="cover"
            priority={true}
            unoptimized={true}
          />
        }
      </Bg>

      <Layout>
        <LayoutTitle>
          <Caption className={"staggerInView"}>{client?.name}</Caption>
          <Title className={"staggerInView"}>{title}</Title>
        </LayoutTitle>

        <LayoutWrapper>

          <LayoutOverview>
            <div>
              <div></div>
              <div className="staggerInView">
                <div>{year}</div>
                <div>
                  {category?.title}
                  {relatedCategories.length > 0 &&
                    ", "
                  }
                  {
                  relatedCategories.map((category) => {
                    return (
                      category.title
                    )
                  }).join(", ")
                }</div>
              </div>
            </div>

          </LayoutOverview>

          {
            dynamicZone.map((zone) => {
              if (zone.__typename == "ComponentPageWorkText") {
                return (
                  <>
                    {zone.heading2 && zone.body2.length <= 0 &&
                      <>
                        {zone.caption.caption === 'video' ? (
                          <LayoutBlock0 dangerouslySetInnerHTML={{ __html: zone.heading2.heading2 }} />
                        ) : (
                          <LayoutBlock0>
                            <div className="staggerInView">
                              <div>{zone.caption.caption}</div>
                              <div>{zone.heading2.heading2}</div>
                            </div>
                          </LayoutBlock0>
                        )}
                      </>
                    }
                    {zone.heading2 && zone.body2.length > 0 &&
                      <LayoutBlock1 className="staggerInView">
                        <div>
                          {zone.caption.caption}
                        </div>
                        <div>
                          <div>
                            {zone.heading2.heading2}
                          </div>
                          <div>
                            {zone.body2.map((body2) => {
                              return (
                                <div dangerouslySetInnerHTML={{ __html: body2.body2 }}></div>
                              )
                            })}
                          </div>
                        </div>
                      </LayoutBlock1>
                    }
                    {zone.heading5 &&
                      <LayoutBlock2 className="staggerInView">
                        <div>
                          {zone.caption?.caption}
                        </div>
                        <div>
                          <div>
                            {zone.heading5.heading5}
                          </div>
                          <div>
                            {zone.body2.map((body2) => {
                              return (
                                <div dangerouslySetInnerHTML={{ __html: body2.body2 }}></div>
                              )
                            })}
                          </div>
                        </div>
                      </LayoutBlock2>
                    }
                  </>
                )
              }
              if (zone.__typename == "ComponentPageWorkImage") {
                return (
                  <>
                    { zone.backdrop ?
                      <LayoutBGWBackdrop className="staggerInView">
                        <img src={zone.image.formats?.large?.url || zone.image.formats?.medium?.url || zone.image.formats?.small?.url || zone.image.formats?.thumbnail?.url} onLoad={() => { scrollRefresh(); }}/>
                      </LayoutBGWBackdrop>
                      :
                      <LayoutImageWCaption className="staggerInView" flexDirectionReversed={zone.captionPosition == "Left" ? true : false}>
                        <div>
                          <img src={zone.image.formats?.large?.url || zone.image.formats?.medium?.url || zone.image.formats?.small?.url || zone.image.formats?.thumbnail?.url} onLoad={() => { scrollRefresh(); }}/>
                        </div>
                        <div>{zone.caption?.caption}</div>
                      </LayoutImageWCaption>
                    }
                  </>
                )
              }
              if (zone.__typename == "ComponentPageWorkImageCarousel") {
                return (
                  <FlickityWrapper className="staggerInView">
                    <Flickity
                      flickityRef={c => (flkty = c)}
                      options={{ initialIndex: 0, pageDots: false, autoPlay: true, prevNextButtons: false }}

                    >
                      {
                        zone.images.map((image, index) => {
                          return (
                            <CarouselCell key={index}>
                              <img src={image.formats?.large?.url || image.formats?.medium?.url || image.formats?.small?.url || image.formats?.thumbnail?.url} onLoad={() => { scrollRefresh(); }}/>
                            </CarouselCell>
                          )
                        })
                      }
                    </Flickity>
                  </FlickityWrapper>
                )
              }
            })
          }

          <HaveQuestions />
        </LayoutWrapper>
      </Layout>
      <Footer />

    {/* <motion.div> */}
    </>
  );
};

export default Work;

export const getServerSideProps: GetServerSideProps = async ({ params }) => {
  console.log(params);
  const response = await cmsApiClient.query({
    query: gql`
      {
        works (where: {
          slug: "${params.slug}"
        }) {
          title,
          year,
          category {
            title
          },
          relatedCategories {
            title
          },
          client {
            name
          },
          cover {
            formats
          },
          dynamicZone {
            __typename
              ...on ComponentPageWorkText {
                id,
                caption {
                  caption
                },
                heading5 {
                  heading5
                },
                heading2 {
                  heading2
                },
                body2 {
                  body2
                }
              }
              ...on ComponentPageWorkImage {
                id,
                caption {
                  caption
                }
                captionPosition,
                backdrop,
                image {
                  formats
                }
              }
              ...on ComponentPageWorkImageCarousel {
                id,
                images {
                  formats
                }
             }
          }
        }
      }
    `,
  });
  return {
    props: response.data.works[0]
  };
};
